export const RULES = {
  required: { message: '请输入', required: true, trigger: ['blur', 'change'] },
  select: { message: '请选择', required: true, trigger: ['change'] },
  phoneNumber: { validator: checkPhone, trigger: ['blur', 'change'] },
  checkInviter: { validator: checkInviter, trigger: ['blur', 'change'] },
}
// 验证手机号
export function checkPhone(rule, value, callback) {
  const reg = /^1[3456789]\d{9}$/
  if (value && !reg.test(value)) {
    callback(new Error('请输入正确的手机号'))
  } else {
    callback()
  }
}

// 验证客户编码
export function checkInviter(rule, value, callback) {
  const reg = /^J[0-9]{10,11}$/
  if (value && !reg.test(value)) {
    callback(new Error('请输入正确的客户编码'))
  } else {
    callback()
  }
}
